export default "__VITE_ASSET__B_gDee2f__"